module.exports = __webpack_public_path__ + "img/nazuna-top.efe96241.png";